import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses';
import { t } from '../../../common/i18n';
import { Dropdown } from '../../../common/react-hook-form/components/Dropdown';
import { mobileActiveChainItems } from '../../PbxAccordionContent/PbxAccordionUtils';
import type { ReachabilityWithMobileFormValues } from '../../PbxAccordionContent/PbxAccordionUtils';
import type { UseFormClearErrors } from 'react-hook-form';

interface MobileActiveChainProps {
  addonAttributes: ReachabilityWithMobileFormValues;
  edit?: boolean;
  clearErrors?: UseFormClearErrors<ReachabilityWithMobileFormValues>;
}

export const MobileActiveChain = ({ addonAttributes, edit = false, clearErrors }: MobileActiveChainProps) => (
  <CL.Grid className={dsClass.PADDING_TOP_7}>
    <CL.GridRow>
      <CL.GridCol colsXS={4} colsS={6} colsM={6} colsL={12} colsXL={12}>
        <h4 className={`${dsClass.MARGIN_BOTTOM_0} ${dsClass.MARGIN_TOP_0}`}>
          {t.VSWS('Reachability with mobile number')}
        </h4>
      </CL.GridCol>
    </CL.GridRow>
    {edit ? (
      <CL.GridRow>
        <CL.GridCol
          className={`${dsClass.PADDING_TOP_4} of-pbx-accordion-content__chain_dropdown`}
          colsXS={4}
          colsS={6}
          colsM={3}
          colsL={6}
          colsXL={6}
        >
          <Dropdown
            name="currentActiveChain"
            items={mobileActiveChainItems()}
            label={t.MM8Z('Active state')}
            onValueChange={() => clearErrors && clearErrors()}
          />
        </CL.GridCol>
      </CL.GridRow>
    ) : (
      <CL.GridRow>
        <CL.GridCol className={dsClass.PADDING_TOP_4} colsXS={4} colsS={6} colsM={3} colsL={6} colsXL={6}>
          <label className={dsClass.INPUT_LABELAREA_LABEL}> {t.MM8Z('Active state')} </label>
          <div className={`${dsClass.PADDING_TOP_1} ${dsClass.PADDING_BOTTOM_1}`}>
            {mobileActiveChainItems().find(item => item.value === addonAttributes.currentActiveChain)?.label ?? '-'}
          </div>
        </CL.GridCol>
      </CL.GridRow>
    )}
  </CL.Grid>
);
